import React, { Fragment } from 'react';
import { Tabs } from 'antd';

import ProductChangeFromOtherTab from "./ProductChangeFromOtherTab";
import ProductChangeToOtherTab from "./ProductChangeToOtherTab";
import { useTexts } from "../../hooks/useTexts";

const ProductChange = (): JSX.Element => {
    const { t } = useTexts();

    return (
        <Fragment>
            <Tabs
                defaultActiveKey="1"
                items={[
                    {
                        label: t('productChange', 'toOurProduct'),
                        key: '1',
                        children: <ProductChangeFromOtherTab />,
                    },
                    {
                        label: t('productChange', 'toOtherProduct'),
                        key: '2',
                        children: <ProductChangeToOtherTab />,
                    },
                ]}
            />
        </Fragment>
    );
};

export default ProductChange;
